export const nodeDefType = {
  integer: 'integer',
  decimal: 'decimal',
  text: 'text',
  date: 'date',
  time: 'time',
  boolean: 'boolean',
  code: 'code',
  coordinate: 'coordinate',
  geo: 'geo',
  taxon: 'taxon',
  file: 'file',
  entity: 'entity',
  // layout elements
  formHeader: 'formHeader',
}
